export default __webpack_public_path__ + "static/media/play-solid.964b5649.svg";